import React from "react";
import FloatingActionButton from "../FloatingActionButton";

export default function ArticleControl({ disabled, onClick, children }) {
  return (
    <div className="flex items-center justify-center w-1/3">
      <FloatingActionButton
        bgColor="white"
        shadow="blur-md"
        disabled={disabled}
        onClick={onClick}
        size="md"
      >
        {children}
      </FloatingActionButton>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/ArticleControl/ArticleControl.js